import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { HouseInvestment } from '@/types';
import '../user.css';
import { formatMoney, formatPrice, trimSixty, trimThirty, trimTwenty } from '@/utils/format';
import { Image } from '@/components/Elements';
import plus from '@/assets/plus.png';
import { changeFav } from '@/api/companyInvestment/changeFav';
import FileViewer from '@/components/Viewer/FileViewer';
import { Modal } from 'react-responsive-modal';
import { Button } from '@/components/Elements/Button';
import { changeAllFav } from '@/api/changeAllFav';
import { deletePropertyItem } from '@/api/deletePropertyItem';
import { useNotificationStore } from '@/stores/notifications';
import { useAuth } from '@/lib/auth';
import storage from '@/utils/storage';
import i18next from 'i18next';
import { upperFirst } from 'lodash';
import { FeatureAdd } from './FeatureAddDialog';

const PropertyDevelopers = ({
  item,
  headData,
  editIcon,
  deleteIcon,
  heartIcon,
  heartFavIcon,
  setHeartClicked,
  setDeleteClicked,
  has_subscription,
}: {
  deleteIcon: boolean;
  item: HouseInvestment;
  headData: boolean;
  editIcon: boolean;
  heartFavIcon: boolean;
  heartIcon: boolean;
  setHeartClicked: any;
  setDeleteClicked: any;
  has_subscription: boolean;
}) => {
  const navigate = useNavigate();
  const localSymbol = storage.getSymbol();
  const localAmount = storage.getAmount();

  const [photo, setPhoto] = useState<any>();
  const [pics, setPics] = useState<any>();
  const [showFeatureAdd, setShowFeatureAdd] = useState(false);

  //   try {
  //     setPics(eval(item?.image_data));

  //     if (item?.image_data) {
  //       if (item.image_data.length === 0) {
  //         setPhoto(null);
  //       } else if (pics) {
  //         setPhoto(pics[0]?.image);
  //       }
  //     } else {
  //       setPhoto(null);
  //     }
  //   } catch (error) {
  //     console.error('Error evaluating image_data:', error);
  //     setPics([]);
  //     setPhoto(null);
  //   }
  // }, [item.image_data, pics]);

  useEffect(() => {
    try {
      if (item?.image_data && item?.image_data.length > 0) {
        const parsed_data = item?.image_data;
        setPhoto(parsed_data[0]);
      }
    } catch (error) {
      console.error('Error evaluating image_data:', error);
    }
  }, [item?.image_data]);

  const [open, setOpen] = useState(false);
  // const onOpenModal = () => setOpen(true);

  const onOpenModals = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setOpen(true);
  };

  const onCloseModal = () => setOpen(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const { user } = useAuth();
  const [favIcon, setFavIcon] = useState<boolean>(!!item.is_favourite);
  const typeVal = 'PropertyDeveloper';
  const deleleItems = async (id: string, types: string) => {
    try {
      setButtonLoading(true);
      await deletePropertyItem(id, types);
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: 'Item deleted successfully!',
      });
    } finally {
      setDeleteClicked(true);
      setOpen(false);
      setButtonLoading(false);
    }
  };

  const deleleItemsSelect = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    deleleItems(item.id, typeVal);
  };
  const changeUnfavStatusAction = async (id: string, type: string) => {
    try {
      const data: any = await changeAllFav(id, type);
      useNotificationStore.getState().addNotification({
        title: 'Success',
        type: 'success',
        message: upperFirst(data?.message),
      });
    } finally {
      setHeartClicked(true);
    }
  };
  const handleUnfavourite = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    changeUnfavStatusAction(item.id, item.type);
    // refetch();
  };

  const changeStatusAction = async (id: string, accept: boolean) => {
    try {
      if (user) {
        await changeFav(id, accept);
        setHeartClicked(true);
      } else {
        useNotificationStore.getState().addNotification({
          title: 'Warning',
          type: 'info',
          message: 'Please Login first!',
        });
        navigate('/auth/login');
      }
    } finally {
    }
  };
  const handleClick = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    setFavIcon((val) => !val);
    changeStatusAction(item.id, false);
  };
  const handleClick2 = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    changeStatusAction(item.id, true);
    setFavIcon((val) => !val);
  };
  const handleEdit = (e: { stopPropagation: () => void }) => {
    e.stopPropagation();
    navigate(`/user/house-investment?id=${item.id}&type=PropertyDevelopers`);
  };
  const handleNavigate = () => {
    navigate(`/house-investment-details/${item.id}?type=PropertyDevelopers`);
  };

  return (
    <>
      <div className="col-12 col-md-6 col-lg-3 home-prop-col">
        <button className="housingButton" onClick={handleNavigate}>
          <div className="item-box deals-page p-2 position-relative">
            {headData == true ? (
              <>
                <div className="head-functions">
                  <span className="status">{i18next.t('Property Developer')}</span>
                  <div className="d-flex icons">
                    {editIcon == true ? (
                      <span>
                        <button onClick={handleEdit}>
                          <i className="fa-solid fa-pen" />
                        </button>
                      </span>
                    ) : null}
                    {deleteIcon == true ? (
                      <span>
                        <button onClick={onOpenModals}>
                          <i className="fa-solid fa-trash" />
                        </button>
                      </span>
                    ) : null}
                    {heartIcon == true ? (
                      <div className=" fav-lists">
                        {favIcon ? (
                          <button onClick={handleClick}>
                            <i className="fa-solid fa-heart"></i>
                          </button>
                        ) : (
                          <button onClick={handleClick2}>
                            <i className="fa-regular fa-heart"></i>
                          </button>
                        )}
                      </div>
                    ) : null}
                    {heartFavIcon == true ? (
                      <div className=" fav-lists">
                        <button onClick={handleUnfavourite}>
                          <i className="fa-solid fa-heart"></i>
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>

                <div className="head-functions3">
                  <span
                    className={`status ${
                      item?.status == 'Approved'
                        ? 'approved'
                        : item?.status == 'Pending'
                        ? 'pending'
                        : 'disapprove'
                    }`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {item?.status}
                  </span>

                  {(has_subscription && item?.status === 'Approved') || item?.is_ad_featured ? (
                    <span className="feature" onClick={(e) => e.stopPropagation()}>
                      Featured
                    </span>
                  ) : (
                    !has_subscription &&
                    !item?.is_ad_featured &&
                    item?.status === 'Approved' && (
                      <span
                        className="status"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowFeatureAdd(true);
                        }}
                      >
                        Add Feature
                      </span>
                    )
                  )}
                </div>
              </>
            ) : (
              <div className="head-functions2 ">
                {item.is_favourite == true ? (
                  <button onClick={handleClick}>
                    <i className="fa-solid fa-heart"></i>
                  </button>
                ) : (
                  <button onClick={handleClick2}>
                    <i className="fa-regular fa-heart"></i>
                  </button>
                )}
              </div>
            )}

            {item?.image_data?.length == 0 ? (
              <FileViewer file={plus ?? ''}></FileViewer>
            ) : (
              <div className='res-slider-icon'>
              <Image
                // imagefallback={eval(item?.image_data)[0]?.image}
                className="itemImage"
                alt="banner"
                src={photo ?? item?.image_data}
              />
              </div>
            )}

            <h6 className="mt-3 text-dark">{trimTwenty(item.short_title)} </h6>
            {item?.location && <p className="mt-3 text-dark text-start stx left-kar text-sm"><i className="fa-solid fa-map-location-dot"></i>{trimThirty(item.location)}</p>}
            {/* {item?.company_address && (
              <h6 className="mt-3 text-dark">{trimThirty(item.company_address)}</h6>
            )} */}
            <p className="text-sm stx">
              {/* {item.company_email} */}
              {/* <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i>
              <i className="fa-solid fa-star"></i> */}
              {/* <span>location : {item.location}</span> */}
            </p>
            {item.description && <p className="text-sm">{trimSixty(item.description)}</p>}
            <p className="text-sm asd">
              {' '}
              {i18next.t('Development')} | {i18next.t('Equity')}
            </p>
            <div className="greyTxt row">
              <p className="col-md-6 col-6 leftw">
                Share For Sale <br />
                {localSymbol} {formatPrice(item.share_for_sale * localAmount)}
                {/* {localSymbol} {formatPrice(item.share_for_sale)} */}

              </p>
              <p className="col-md-6 col-6 leftww">
                {i18next.t('Valuation')}
                <br />
                {localSymbol} {formatPrice(item.the_valuation * localAmount)}
                
                {/* {localSymbol} {formatPrice(item.the_valuation )} */}

              </p>
            </div>
            {/* <h6 className="mt-3 text-dark">{item.company_name}</h6>
          {location && (
            <p className="text-sm">
              <i className="fa-solid fa-map-location-dot"></i>
              {item.company_details}
            </p>
          )}
          <div className="tab">
            <p>{i18next.t('Valuation')}</p>
            <p>{formatMoney(item.the_valuation)}</p>
          </div>
          <div className="tab">
            <p>Share For Sale</p>
            <p>{formatMoney(item.shares_for_sale)}</p>
          </div>
          <div className="tab">
            <p>Remaining Share</p>
            <p>{formatMoney(item.remaninig_shares)}</p>
          </div>
          <div className="tab">
            <p>Minimum Drawing</p>
            <p>{formatPercent(item.minimum_drawing)}</p>
          </div> */}
          </div>
        </button>
        <Modal open={open} onClose={onCloseModal} center>
          <section className="model-datas text-center">
            <h3> {i18next.t('Are you sure you want to delete this property ?')}</h3>
          </section>
          <p className="btn-lines delete-bots d-flex justify-content-center">
            <Button isLoading={buttonLoading} onClick={deleleItemsSelect}>
              {i18next.t('Yes')}
            </Button>
            <Button onClick={onCloseModal}>{i18next.t('No')}</Button>
          </p>
        </Modal>
      </div>

      <FeatureAdd
        propType="property_developer"
        propId={item.id}
        show={showFeatureAdd}
        setShow={setShowFeatureAdd}
      />
    </>
  );
};

export default PropertyDevelopers;
